import { render } from "./MyExperts.vue?vue&type=template&id=0323956b&scoped=true"
import script from "./MyExperts.vue?vue&type=script&lang=js"
export * from "./MyExperts.vue?vue&type=script&lang=js"

import "./MyExperts.vue?vue&type=style&index=0&id=0323956b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0323956b"]])

export default __exports__